import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    margin-bottom: 56px;
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 13px;
    box-shadow: 0px 4px 8px 3px rgba(0, 0, 0, 0.15),
      0px 1px 3px rgba(0, 0, 0, 0.3);
    background: ${colors.white};
  `,
  imageContainer: css`
    width: 50%;
    text-align: center;
  `,
  description: css`
    padding-top: 4px;
    display: flex;
    white-space: nowrap;
  `,
  image: css`
    object-fit: cover;
    max-height: ${pxToRem(70)};
    width: auto;
    max-width: ${pxToRem(70)};;
  `,
  section: css`
    display: flex;
    align-items: center;
    flex-direction: row;
    height: 100%;
  `,
  card: css`
    cursor: pointer;
    & + div {
      border-top: 1px solid ${colors.mercury};
    }
  `,
  districtSection: css`
    height: ${pxToRem(82)};
    margin: 16px 8px 16px 24px;
    @media (min-width: 800px) {
      margin: 16px 24px;
    }
  `,
  schoolSection: css`
    padding: 24px 8px 24px 24px;
    @media (min-width: 800px) {
      padding: 16px 24px;
    }
  `,
  infoSection: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    flex: 1;
    justify-content: space-between;
  `,
  infoDetails: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
    flex-grow: 1;
  `,
  institutionName: css`
    @media (max-width: 480px) {
      white-space: nowrap;
      width: ${pxToRem(149)};
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `,
  communityName: css`
    @media (max-width: 480px) {
      white-space: nowrap;
      width: ${pxToRem(180)};
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `,
  illustration: css`
    width: 100%;
    height: ${pxToRem(168)};

    img {
      width: 100%;
      height: 100%;
    }
    border-bottom: 1px solid ${colors.mercury};
    padding-bottom: 5px;
  `,
  title: css`
    text-transform: capitalize;
    font-size: 18px;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: ${colors.white};
    padding: 16px 4px;
    border-radius: 5px;
  `,
};

export default styles;
